import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { LinkedInExtCandidates } from '@/features/linkedin-ext-candidates'

const searchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(20),
  filter: z.string().optional().catch(''),
  isPremium: z.boolean().optional().catch(undefined),
  isCreator: z.boolean().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/linkedin-ext-candidates/')({
  validateSearch: searchSchema,
  component: LinkedInExtCandidates,
})
